module.exports = __webpack_public_path__ + "static/media/contact info icon (active).6b204eae.svg";